import Component from '@glimmer/component'
import PhosphorIcon from 'teacher-ui-client/components/phosphor-icon'
import { service } from '@ember/service'
import { ToolkitPreview, isValidToolkitActivity } from 'teacher-ui-client/interactive-preview/engines'
import type InteractivePreviewService from 'teacher-ui-client/services/interactive-preview'
import { on } from '@ember/modifier'
import { type TeacherResourceActivityEntry } from 'teacher-ui-client/contentful-client/entry-types'
import { getId } from 'teacher-ui-client/contentful-client/entry-types'
import { ContentfulEdit } from 'teacher-ui-client/components/contentful/edit'

interface Signature {
  Args: {
    resource: TeacherResourceActivityEntry
  }
}

export class ResourcesListActivity extends Component<Signature> {
  @service interactivePreview!: InteractivePreviewService

  /**
   * accepts a string like /buzzys_word_machine/1 , used by contentful entries in teacher toolkit
   */
  openToolkitInteractive = () => {
    const entryPath = this.args.resource.fields.src
    if (!entryPath) return

    const withoutLeadingSlash = entryPath.charAt(0) === '/' ? entryPath.substring(1) : entryPath
    const parts = withoutLeadingSlash.split('/')

    if (isValidToolkitActivity(parts[0]) && typeof parts[1] === 'string') {
      this.interactivePreview.openPreview(
        new ToolkitPreview(this, this.interactivePreview.curriculum, parts[0], parts[1]),
        { title: this.args.resource.fields.name },
      )
    }
  }

  <template>
    <button type="button" class="default-link-style" {{on "click" this.openToolkitInteractive}}>
      <PhosphorIcon @icon="phosphor-puzzle-piece-fill" class="mr-2 h-5 w-5" />
      {{@resource.fields.name}}
    </button>
    <ContentfulEdit @entryId={{getId @resource}} class="ml-4" />
  </template>
}

export default ResourcesListActivity
